import React, { useEffect } from 'react'
import { RecoilRoot } from "recoil"
import decode from 'jwt-decode'
import Routes from './Routes'
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import './myMdbreact/css/mdb.css'
import './App.css'

function App() {
  return (
    <RecoilRoot>
      <Routes />
    </RecoilRoot>
  );
}

export default App;
